export const HEADER_HEIGHT = '64px'

export const ROOT_SIDEBAR_WIDTH = '232px'

export const TOOLBAR_HEIGHT = '48px'
export const DOCUMENT_HEADER_HEIGHT = '112px'

// Accounts for extra pixel added by borders
export const DOCUMENT_CONTENT_HEIGHT = `calc(100vh - ${DOCUMENT_HEADER_HEIGHT} - 1px)`
export const ARTICLE_EDITOR_CONTENT_HEIGHT = `calc(100vh - ${DOCUMENT_HEADER_HEIGHT} - ${TOOLBAR_HEIGHT} - 2px)`

export const TAGGING_SIDEBAR_WIDTH = '100px'

export const CHAT_BUBBLE_WIDTH = '45rem'

export const LAYERS = {
  RaisedElement: 20,
  SectionHeader: 30,
  PageHeader: 40,

  Header: 50,
  Sidebar: 60,

  Fullscreen: 1000,
  Popover: 1010,
  Modal: 1020,
  Dropdown: 1030,
  Tooltip: 1040,
}

export const BREAKPOINTS = {
  xs: 480,
  sm: 768,
  md: 1024,
  lg: 1440,
}

export const SPACERS = {
  xxs: '0.25rem', // 4px
  xs: '0.5rem', // 8px
  sm: '0.75rem', // 12px
  md: '1rem', // 16px
  lg: '1.25rem', // 20px
  xl: '1.5rem', // 24px
  xxl: '2rem', // 32px
  xxxl: '2.5rem', // 40px
  xxxxl: '3rem', // 48px
}

export const LETTER_SPACING = {
  tight: '0.015rem',
  normal: '0.025rem',
  wide: '0.035rem',
}

export const FONT_WEIGHTS = {
  thin: 100,
  extraLight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,
}

export const RevealElementCSS = ` 
opacity: 0; /* Start invisible */
mask-image: linear-gradient(to top, transparent 0%, black 100%); /* Initial mask */
transform: translateY(8px); /* Start slightly below */
animation: revealText 1.5s ease forwards; /* Apply the animation */

@keyframes revealText {
    0% {
  opacity: 0; /* Invisible at the start */
  mask-image: linear-gradient(to top, transparent 0%, black 100%); /* Full mask */
  transform: translateY(8px); /* Start slightly below */
    }
    50% {
  mask-image: linear-gradient(to top, transparent 0%, black 0%); /* No mask */
    }
    100% {
  opacity: 1; /* Fully visible at the end */
  mask-image: linear-gradient(to top, transparent 0%, black 0%); /* No mask */
  transform: translateY(0px); /* End at the top */
    }
}`
